import { render, staticRenderFns } from "./RecentProjects.vue?vue&type=template&id=603b501c&scoped=true&"
import script from "./RecentProjects.vue?vue&type=script&lang=js&"
export * from "./RecentProjects.vue?vue&type=script&lang=js&"
import style0 from "./RecentProjects.vue?vue&type=style&index=0&id=603b501c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "603b501c",
  null
  
)

export default component.exports